module.exports = "img/settings-big.bb25bab.png";